export default {
  namespaced: true,
  modules: {
    'md-store': require('./md-store').default
  }
}
